module.exports = "/images/vendor/flag-icon-css/flags/4x3/bf.svg?9a958401fd126a3c08686ece9477cea3";